import { PreviewCard, styled } from '@zeiss/beyond-online-react';

// Better compatibility with `desktopVariant="grid-item"` option
export const StyledPreviewCard = styled(PreviewCard)`
  width: 100%;
  max-width: none;
  height: 100%;
`;
